
import {Component, Vue} from "vue-property-decorator";
import DataFields from "@/components/study/DataFields.vue";

@Component({
  components: {
    DataFields
  }
})
export default class InstrumentEdit extends Vue {

}

